import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const AmbassadorMedalIcon = withDefaultIconProps(
  {
    height: 32,
    width: 32,
  },
  ({ color, ...rest }) => (
    <Svg {...rest}>
      <Path
        d="M8.581 10.667A11.466 11.466 0 008 14.303C8 19.659 11.58 24 16 24m0 0c4.419 0 8-4.341 8-9.697a11.467 11.467 0 00-.581-3.636M15.999 24c2.425 0 3.334 4 3.334 4M16 24c-2.424 0-3.334 4-3.334 4M24.694 6.973c.39 2.222-1.36 3.694-1.36 3.694s-2.137-.751-2.526-2.974C20.416 5.472 22.166 4 22.166 4s2.137.75 2.526 2.973z"
        fill="none"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7.69 24.253c2-.768 2.31-2.92 2.31-2.92s-1.69-1.385-3.69-.617S4 23.636 4 23.636s1.69 1.384 3.69.616m20.435-8.065c-1.708 1.688-4.021 1.013-4.021 1.013s-.605-2.363 1.104-4.053c1.707-1.688 4.021-1.014 4.021-1.014s.606 2.363-1.104 4.054zm-3.813 8.066c-2-.768-2.312-2.92-2.312-2.92s1.69-1.384 3.69-.617c2 .768 2.31 2.92 2.31 2.92s-1.688 1.384-3.688.617zM3.875 16.187c1.706 1.688 4.02 1.013 4.02 1.013s.606-2.363-1.103-4.053C5.084 11.46 2.77 12.133 2.77 12.133s-.606 2.363 1.104 4.054zm3.432-9.214c-.39 2.222 1.36 3.694 1.36 3.694s2.137-.751 2.526-2.974C11.583 5.472 9.833 4 9.833 4s-2.137.75-2.526 2.973z"
        fill="none"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  ),
);
